import {
  uaGlobalReleaseConstants,
  addUAGlobalReleaseConstants,
  editUAGlobalReleaseConstants,
} from "../_redux-constants";

export function uaGlobalReleaseReducer(
  state = {
    uaGlobalReleaseLoading: false,
    uaGlobalReleaseData: null,
    uaGlobalReleaseError: null,

    addUAGlobalReleaseLoading: false,
    addUAGlobalReleaseData: null,
    addUAGlobalReleaseError: null,

    editUAGlobalReleaseLoading: false,
    editUAGlobalReleaseData: null,
    editUAGlobalReleaseError: null,
  },
  action
) {
  switch (action.type) {
    case uaGlobalReleaseConstants.UA_GLOBAL_RELEASE_LOADING:
      return Object.assign({}, state, {
        uaGlobalReleaseLoading: true,
        uaGlobalReleaseData: null,
        uaGlobalReleaseError: null,
        addUAGlobalReleaseLoading: false,
        addUAGlobalReleaseData: null,
        addUAGlobalReleaseError: null,
      });
    case uaGlobalReleaseConstants.UA_GLOBAL_RELEASE_SUCCESS:
      return Object.assign({}, state, {
        uaGlobalReleaseLoading: false,
        uaGlobalReleaseData: action.data,
      });
    case uaGlobalReleaseConstants.UA_GLOBAL_RELEASE_FAILURE:
      return Object.assign({}, state, {
        uaGlobalReleaseLoading: false,
        uaGlobalReleaseData: null,
        uaGlobalReleaseError: action.error,
      });

    case addUAGlobalReleaseConstants.ADD_UA_GLOBAL_RELEASE_LOADING:
      return Object.assign({}, state, {
        addUAGlobalReleaseLoading: true,
        addUAGlobalReleaseData: null,
        addUAGlobalReleaseError: null,
      });
    case addUAGlobalReleaseConstants.ADD_UA_GLOBAL_RELEASE_SUCCESS:
      return Object.assign({}, state, {
        addUAGlobalReleaseLoading: false,
        addUAGlobalReleaseData: action.data,
      });
    case addUAGlobalReleaseConstants.ADD_UA_GLOBAL_RELEASE_FAILURE:
      return Object.assign({}, state, {
        addUAGlobalReleaseLoading: false,
        addUAGlobalReleaseData: null,
        addUAGlobalReleaseError: action.error,
      });

    case editUAGlobalReleaseConstants.EDIT_UA_GLOBAL_RELEASE_LOADING:
      return Object.assign({}, state, {
        editUAGlobalReleaseLoading: true,
        editUAGlobalReleaseData: null,
        editUAGlobalReleaseError: null,
      });
    case editUAGlobalReleaseConstants.EDIT_UA_GLOBAL_RELEASE_SUCCESS:
      return Object.assign({}, state, {
        editUAGlobalReleaseLoading: false,
        editUAGlobalReleaseData: action.data,
      });
    case editUAGlobalReleaseConstants.EDIT_UA_GLOBAL_RELEASE_FAILURE:
      return Object.assign({}, state, {
        editUAGlobalReleaseLoading: false,
        editUAGlobalReleaseData: null,
        editUAGlobalReleaseError: action.error,
      });

    default:
      return state;
  }
}
